import {useQuery} from 'react-query'
import {deleteRoot, fetchRootList} from './api'
import {PageTitle} from '../../../_metronic/layout/core'
import {Error500} from '../../modules/errors/components/Error500'
import CRUDTable from '../../../components/table/CRUDTable'
import toast, {Toaster} from 'react-hot-toast'
import viewProps from '../viewProps'
import {Processing} from '../../../components/Loaders'
import RootForm from './Form'
import ModalWithForm from '../../../components/ModalWithForm'
import DeleteButton from '../../../components/DeleteButton'
import EditBtn from '../../../components/EditBtn'
import {Button} from 'react-bootstrap'
import {Helmet} from 'react-helmet'
import PortalDropdown from '../../../components/PortalDropdown'
import EditLabel from '../../../components/EditLabel'
import DeleteConfirmationModal from '../../../components/DeleteWarning'
import DeleteLabel from '../../../components/DeleteLabel'
import TopBarProgress from 'react-topbar-progress-indicator'

const routeBreadcrumbs = [
  {
    title: 'School Management',
    path: 'school-management/routes',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

function Roots() {
  const {data, isError, isFetching, isLoading, refetch} = useQuery('routesList', fetchRootList, {
    refetchOnWindowFocus: false,
  })

  if (isLoading) {
    return <Processing />
  }

  const cellModifier = {
    Actions: ({row}) => {
      return (
        <PortalDropdown triggerProps={{className: 'btn btn-secondary px-0 py-1'}}>
          <span className="dropdown-item p-0">
            <ModalWithForm
              modalTitle={'Update Route'}
              initialValues={row.original}
              onSubmit={refetch}
              Form={RootForm}
              modalAttrs={{size: 'sm'}}
              triggerClassName="d-block"
            >
              <EditLabel />
            </ModalWithForm>
          </span>
          <span className="dropdown-item p-0">
            <DeleteConfirmationModal
              triggerClassName="d-block"
              onDelete={async () => {
                const toastId = toast.loading('Deleting Please wait...')
                try {
                  const response = await deleteRoot(row.original.route_id)
                  if (response?.status === false && response?.message) {
                    toast.error(response.message, {id: toastId})
                    return null
                  }
                  await refetch()
                  toast.success('Deleted Successfully', {id: toastId})
                } catch (error) {
                  toast.error('Something went wrong, please try again later', {id: toastId})
                }
              }}
            >
              <DeleteLabel />
            </DeleteConfirmationModal>
          </span>
        </PortalDropdown>
      )
    },
  }

  return (
    <>
      <Helmet>
        <title>TrackNAB | Bus Routes</title>
      </Helmet>
      <PageTitle breadcrumbs={routeBreadcrumbs}>Routes</PageTitle>
      {isError ? (
        <div className="text-center">
          <Error500 />
        </div>
      ) : (
        <CRUDTable
          data={data?.data || []}
          {...viewProps.Roots}
          fieldToLabelMap={viewProps.Roots.primaryFieldsToLabelMap}
          cellModifier={cellModifier}
          nonSortableColumns={['Actions']}
          headerExtras={
            <ModalWithForm
              modalTitle={'Add Route'}
              triggerClassName="ms-auto"
              onSubmit={refetch}
              Form={RootForm}
              modalAttrs={{size: 'sm'}}
            >
              <Button size="sm">Add Route</Button>
            </ModalWithForm>
          }
        />
      )}
      {isFetching && <TopBarProgress />}

      <Toaster />
    </>
  )
}

export default Roots
